import { merge, cloneDeep } from 'lodash';

import { editionDefaultState } from '@/common/store';

const printState = {
  book: {
    coverOption: '',
    numberMaxPages: 0,
    pageInfo: {}
  },
  hideSafeMargin: false,
  hideTrimLineBleed: false,
  favLayouts: []
};

export const state = merge(cloneDeep(editionDefaultState), printState);
